import React from "react";
import { useNavigate } from "react-router-dom";
import {
  FaPhone,
  FaPaperPlane,
  FaEnvelopeOpenText,
  FaClipboardList,
  FaPlaneDeparture,
} from "react-icons/fa";
import "../WhyChoose/WhyChoose.css";

const WhyChoose = () => {
  const navigate = useNavigate();

  const handleCall = () => {
    window.location.href = "tel:02033557350  ";
  };

  const handleClick = () => {
    navigate("/contactus", {
      state: { scrollTo: "fm" }
    });
  };

  const handleEmail = () => {
    const subject = encodeURIComponent("Click4Travel Enquiry");
    const body = encodeURIComponent(
      "Hi Team,\n\nI’d like to know more about your flight deals.\n\nThanks,"
    );
    window.location.href = `mailto:info@click4flight.co.uk?subject=${subject}&body=${body}`;
  };

  const handleCheckFlights = () => {
    navigate("/flight");
  };

  return (
    <section className="why-choose-container-wc-abc">
      {/* LEFT */}
      <div className="left-side-wc-abc">
        <h2 className="heading-wc-abc">Why Book With Us?</h2>

        <ul className="list-wc-abc">
          {[
            "Exclusive 'Off-Market' Fares – Access private, long-haul rates unavailable on public search engines.",
            "Total Price Assurance – Premium service matched with the most competitive market rates.",
            "Flexible Payment Security – Secure your journey with low deposits and flexible payment plans.",
            "Human-Led Expertise – Bespoke itineraries designed by worldwide specialists, not algorithms.",
            "100% ATOL Protection – For your financial safety and peace of mind.",
            "Worldwide Support – Dedicated UK-based assistance from takeoff to touchdown.",
          ].map((item, index) => {
            const htmlText = item.replace(
              /^([^–]+)–/,
              "<strong>$1</strong>–"
            );

            return (
              <li className="list-item-wc-abc" key={index}>
                <FaPaperPlane className="icon-wc-abc" />
                <span
                  dangerouslySetInnerHTML={{ __html: htmlText }}
                />
              </li>
            );
          })}
        </ul>
      </div>

      {/* RIGHT */}
      <div className="right-side-wc-abc">
        <div className="card-wc-abc" onClick={handleCall}>
          <FaPhone className="card-icon-wc-abc" />
          <div>
            <h3 className="card-title-wc-abc">Call Our Experts</h3>
            <p className="card-text-wc-abc">
              Speak to a specialist for instant booking & hidden deals.
            </p>
          </div>
        </div>

        <div className="card-wc-abc" onClick={handleClick}>
          <FaClipboardList className="card-icon-wc-abc" />
          <div>
            <h3 className="card-title-wc-abc">Request a Quote</h3>
            <p className="card-text-wc-abc">
              Get a personalized itinerary delivered to your inbox.
            </p>
          </div>
        </div>

        <div className="card-wc-abc" onClick={handleEmail}>
          <FaEnvelopeOpenText className="card-icon-wc-abc" />
          <div>
            <h3 className="card-title-wc-abc">Exclusive Alerts </h3>
            <p className="card-text-wc-abc">
              Join our list for first access to luxury fare drops.
            </p>
          </div>
        </div>

        {/*---
        <div className="card-wc-abc highlight-abc" onClick={handleCheckFlights}>
          <FaPlaneDeparture className="card-icon-wc-abc" />
          <div>
            <h3 className="card-title-wc-abc">Check Flights</h3>
            <p className="card-text-wc-abc">
              Search & compare the latest flights
            </p>
          </div>
        </div>
        --*/}
      </div>
    </section>
  );
};

export default WhyChoose;